var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.57143 15H8.42857H1.57143ZM5 1V9.90909V1ZM5 9.90909L9 5.45455L5 9.90909ZM5 9.90909L1 5.45455L5 9.90909Z",
    fill: "#0B49EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.57143 15H8.42857M5 1V9.90909M5 9.90909L9 5.45455M5 9.90909L1 5.45455",
    stroke: "#0B49EB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.8681418250bef5eaef020bd8c45c1f5a.svg";
export { ForwardRef as ReactComponent };